// extracted by mini-css-extract-plugin
module.exports = {"view-chart":"_2P8Yf-","viewChart":"_2P8Yf-"};